__turbopack_context__.v({
  "affirm_button": "affirm-buttons-module-scss-module__kS7_zq__affirm_button",
  "icon-american-express": "affirm-buttons-module-scss-module__kS7_zq__icon-american-express",
  "icon-arrow": "affirm-buttons-module-scss-module__kS7_zq__icon-arrow",
  "icon-chat": "affirm-buttons-module-scss-module__kS7_zq__icon-chat",
  "icon-cross": "affirm-buttons-module-scss-module__kS7_zq__icon-cross",
  "icon-discover": "affirm-buttons-module-scss-module__kS7_zq__icon-discover",
  "icon-mastercard": "affirm-buttons-module-scss-module__kS7_zq__icon-mastercard",
  "icon-visa": "affirm-buttons-module-scss-module__kS7_zq__icon-visa",
  "location": "affirm-buttons-module-scss-module__kS7_zq__location",
  "phone": "affirm-buttons-module-scss-module__kS7_zq__phone",
  "trade-mark": "affirm-buttons-module-scss-module__kS7_zq__trade-mark",
  "wrapper": "affirm-buttons-module-scss-module__kS7_zq__wrapper",
});
